import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./Auth/authSlice";
import ProfileReducer from "./Profile/profileSlice";
import MatchReducer from "./Matches/matchSlice";
import SeriesReducer from "./Series/seriesSlice";
import AccumulatorReducer from "./Series/accumulatorSlice";
import ContactReducer from "./contactSlice";
import PaymentReducer from "./Payment/PaymentSlice";
import WalletReducer from "./Wallet/walletSlice";
import FaqReducer from "./CMS/cmsSlice";
import NotificationReducer from "./Notification/NotificationSlice";
import getColorReducer from "./getColor/getColorSlice";

export const store = configureStore({
  reducer: {
    auth: AuthReducer,
    profile: ProfileReducer,
    match: MatchReducer,
    series: SeriesReducer,
    accumulator: AccumulatorReducer,
    wallet: WalletReducer,
    contact: ContactReducer,
    payment: PaymentReducer,
    cms: FaqReducer,
    notification: NotificationReducer,
    colors: getColorReducer,
  },
});
